import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { DefaultConfig } from '../../settings/config'
import ToastMessage from '../../components/toast-messages'
import toast from 'react-hot-toast'
import { ApiUrls } from '../../utility/ApiUrls'

export const displayMenu = createAsyncThunk("appCommonReducers/displayMenu", async (displayMenuBool) => {
  return displayMenuBool
})

let getUserCall = false

const normalizeIsActive = (value) => {
  if (typeof value === 'boolean') {
    return value
  }
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase()
    return normalized === 'true' || normalized === '1'
  }
  if (typeof value === 'number') {
    return value === 1
  }
  return false
}

const apiCall = async (method, endpoint, requestPayload) => {
  const authAxios = DefaultConfig().authAxios
  if (method === 'get') {
    return await authAxios.get(endpoint)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'post') {
    return await authAxios.post(endpoint, requestPayload)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'patch') {
    return await authAxios.patch(endpoint, requestPayload)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'delete') {
    return await authAxios.delete(endpoint, { data: requestPayload })
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  }
}

export const GetUsers = createAsyncThunk("appCommonReducers/GetUsers", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetUsers}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    const allUsers = []
    resultData.forEach((element) => {
      allUsers.push({
        userId: element.id,
        name: element.fullName,
        email: element.email,
        companyId: element.companyId,
        status: normalizeIsActive(element.isActive) ? 'Active' : 'InActive'
      })
    })
    return {
      data: allUsers,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetAllUsers = createAsyncThunk("appCommonReducers/GetAllUsers", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetAllUsers}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    const allUsers = []
    resultData.forEach((element) => {
      const userId = element.id ?? element.userId
      const email = element.email || element.mail || ''
      const givenName = element.givenName || element.fuvenname || element.firstName || ''
      const surname = element.surname || element.lastName || ''
      const fullName = `${givenName} ${surname}`.trim() || element.fullName || element.displayName || ''
      allUsers.push({
        userId,
        email,
        name: fullName,
        status: normalizeIsActive(element.isActive) ? 'Active' : 'InActive'
      })
    })
    return {
      data: allUsers,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetAllRoles = createAsyncThunk("appCommonReducers/GetAllRoles", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetAllRoles}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetUserRoles = createAsyncThunk("appCommonReducers/GetUserRoles", async (uid) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetUserRoles}?userId=${uid}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)


  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const SaveUserRoles = createAsyncThunk("appCommonReducers/SaveUserRoles", async (rdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.SaveUserRoles}?userId=${rdata.userId}`
  const data = rdata.data
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const CreateUser = createAsyncThunk("appCommonReducers/CreateUser", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.CreateUser}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

export const UpdateUser = createAsyncThunk("appCommonReducers/UpdateUser", async (payload) => {
  const method = 'patch'
  const endpoint = `${ApiUrls.UpdateUser}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetEnvelopebyEnvelopeId = createAsyncThunk("appCommonReducers/GetEnvelopebyEnvelopeId", async (params = {}) => {
  const method = 'get'
  const queryParams = new URLSearchParams()
  
  if (params.fromDate) {
    queryParams.append('FromDate', params.fromDate)
  }
  if (params.toDate) {
    queryParams.append('ToDate', params.toDate)
  }
  if (params.envelopeId) {
    queryParams.append('EnvelopeId', params.envelopeId)
  }
  
  const queryString = queryParams.toString()
  const endpoint = `${ApiUrls.GetEnvelopebyEnvelopeId}${queryString ? `?${queryString}` : ''}`
  
  const resultData = await apiCall(method, endpoint, '')

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetCombinedDocuments = createAsyncThunk("appCommonReducers/GetCombinedDocuments", async (envelopeId) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetCombinedDocuments}?envelopeId=${envelopeId}`
  const resultData = await apiCall(method, endpoint, '')

  if (resultData) {
    return {
      data: resultData,
      spinner: false,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: false,
      tokenExp: false
    }
  }
})

export const GetCertificate = createAsyncThunk("appCommonReducers/GetCertificate", async (envelopeId) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetCertificate}?envelopeId=${envelopeId}`
  const resultData = await apiCall(method, endpoint, '')

  if (resultData) {
    return {
      data: resultData,
      spinner: false,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: false,
      tokenExp: false
    }
  }
})

export const GetEnvelopeCustomFields = createAsyncThunk("appCommonReducers/GetEnvelopeCustomFields", async (envelopeId) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetEnvelopeCustomFields}?envelopeId=${envelopeId}`
  const resultData = await apiCall(method, endpoint, '')

  if (resultData) {
    return {
      data: resultData,
      spinner: false,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: false,
      tokenExp: false
    }
  }
})

export const GetEnvelopeRecipients = createAsyncThunk("appCommonReducers/GetEnvelopeRecipients", async (envelopeId) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetEnvelopeRecipients}?envelopeId=${envelopeId}`
  const resultData = await apiCall(method, endpoint, '')

  if (resultData) {
    return {
      data: resultData,
      spinner: false,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: false,
      tokenExp: false
    }
  }
})

export const GetEnvelopeDocuments = createAsyncThunk("appCommonReducers/GetEnvelopeDocuments", async (envelopeId) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetEnvelopeDocuments}?envelopeId=${envelopeId}`
  const resultData = await apiCall(method, endpoint, '')

  if (resultData) {
    return {
      data: resultData,
      spinner: false,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: false,
      tokenExp: false
    }
  }
})

export const GetNotification = createAsyncThunk("appCommonReducers/GetNotification", async (envelopeId) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetNotification}?envelopeId=${envelopeId}`
  const resultData = await apiCall(method, endpoint, '')

  if (resultData) {
    return {
      data: resultData,
      spinner: false,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: false,
      tokenExp: false
    }
  }
})

export const ReSendDocument = createAsyncThunk("appCommonReducers/ReSendDocument", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.ReSendDocument}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: false,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: false,
      tokenExp: false
    }
  }
})

export const VoidEnvelope = createAsyncThunk("appCommonReducers/VoidEnvelope", async (envelopeId) => {
  const method = 'delete'
  const endpoint = `${ApiUrls.VoidEnvelope}?envelopeId=${envelopeId}`
  const resultData = await apiCall(method, endpoint, '')

  if (resultData) {
    return {
      data: resultData,
      spinner: false,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: false,
      tokenExp: false
    }
  }
})

export const DownloadDocument = createAsyncThunk("appCommonReducers/DownloadDocument", async (params) => {
  const authAxios = DefaultConfig().authAxios
  const { envelopeId, documentId } = params
  const endpoint = `${ApiUrls.DownloadDocument}?envelopeId=${envelopeId}&documentId=${documentId}`
  
  try {
    // Try as blob first (for direct file downloads)
    const response = await authAxios.get(endpoint, {
      responseType: 'blob'
    })
    
    // Check if response is a blob
    if (response.data instanceof Blob) {
      // Check if blob is actually JSON (API might return JSON with base64)
      try {
        const blobText = await response.data.text()
        const jsonData = JSON.parse(blobText)
        // If it's JSON with base64 data structure (like other DocuSign endpoints)
        if (jsonData && jsonData.success && jsonData.data) {
          return {
            data: jsonData.data,
            spinner: false,
            tokenExp: false
          }
        }
        // If it's JSON but different structure, return the data
        if (jsonData && jsonData.data) {
          return {
            data: jsonData.data,
            spinner: false,
            tokenExp: false
          }
        }
      } catch (e) {
        // Not JSON, it's a real blob - return as blob
        return {
          data: response.data,
          spinner: false,
          tokenExp: false
        }
      }
    }
    
    return {
      data: response.data,
      spinner: false,
      tokenExp: false
    }
  } catch (error) {
    const errorresponse = error.response
    if (errorresponse) {
      const status = errorresponse.status
      if (status === 403) {
        return {
          data: null,
          spinner: false,
          tokenExp: false
        }
      } else if (status === 406) {
        toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
        return {
          data: null,
          spinner: false,
          tokenExp: false
        }
      } else if (status === 419) {
        if (!getUserCall) {
          getUserCall = true
          toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
        }
        return {
          data: null,
          spinner: false,
          tokenExp: false
        }
      } else if (status === 401) {
        localStorage.clear()
        window.location.reload()
        return {
          data: null,
          spinner: false,
          tokenExp: false
        }
      } else {
        toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
        return {
          data: null,
          spinner: false,
          tokenExp: false
        }
      }
    }
    return {
      data: null,
      spinner: false,
      tokenExp: false
    }
  }
})

export const GetFilteredEnvelopes = createAsyncThunk("appCommonReducers/GetFilteredEnvelopes", async (filters = {}) => {
  const method = 'get'
  const params = new URLSearchParams()
  
  if (filters.fromDate) {
    params.append('FromDate', filters.fromDate)
  }
  if (filters.toDate) {
    params.append('ToDate', filters.toDate)
  }
  if (filters.status) {
    params.append('Status', filters.status)
  }
  if (filters.envelopeId) {
    params.append('EnvelopeId', filters.envelopeId)
  }
  
  const queryString = params.toString()
  const endpoint = `${ApiUrls.GetFilteredEnvelopes}${queryString ? `?${queryString}` : ''}`
  
  const resultData = await apiCall(method, endpoint, '')

  if (resultData) {
    let envelopes = []
    if (Array.isArray(resultData)) {
      envelopes = resultData
    } else if (resultData.data && Array.isArray(resultData.data)) {
      envelopes = resultData.data
    } else if (resultData.success && resultData.data && Array.isArray(resultData.data)) {
      envelopes = resultData.data
    }
    
    return {
      data: envelopes,
      spinner: false,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: false,
      tokenExp: false
    }
  }
})

export const GetDPPReportByDate = createAsyncThunk("appCommonReducers/GetDPPReportByDate", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetInspectionDashboardData}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetCategories = createAsyncThunk("appCommonReducers/GetCategories", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetCategories}`
  const resultData = await apiCall(method, endpoint, '')

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetCategorieTypesDescription = createAsyncThunk("appCommonReducers/GetCategorieTypesDescription", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetCategorieTypesDescription}`
  const resultData = await apiCall(method, endpoint, wdata)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetAllKeys = createAsyncThunk("appCommonReducers/GetAllKeys", async (filters = {}) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetAllKeys}`
  const data = {
    key: filters.key ?? '',
    page: filters.page ?? 1,
    pageSize: filters.pageSize ?? 9
  }

  const result = await apiCall(method, endpoint, data)

  if (result) {
    return {
      keys: result.data || [],
      pagination: {
        page: result.page ?? data.page,
        pageSize: result.pageSize ?? data.pageSize,
        total: result.total ?? 0
      }
    }
  } else {
    return {
      keys: [],
      pagination: {
        page: data.page,
        pageSize: data.pageSize,
        total: 0
      }
    }
  }
})

export const GetKeyDetails = createAsyncThunk("appCommonReducers/GetKeyDetails", async (key) => {

  const method = "get"
  const encodedKey = encodeURIComponent(key)

  const endpoint = `${ApiUrls.GetKeyDetails}?key=${encodedKey}`

  const result = await apiCall(method, endpoint, "")

  if (result) {
    return {
      keyDetails: result,
      keyDetailsSpinner: false
    }
  } else {
    return {
      keyDetails: null,
      keyDetailsSpinner: false
    }
  }
}
)

export const DeleteKeys = createAsyncThunk("appCommonReducers/DeleteKeys", async (keys) => {
  const method = 'delete'
  const endpoint = `${ApiUrls.DeleteKeys}`
  
  // Format: { "keys": [...] }
  const data = {
    keys: Array.isArray(keys) ? keys : [keys]
  }

  const result = await apiCall(method, endpoint, data)
  const keysArray = Array.isArray(keys) ? keys : [keys]

  if (result) {
    return {
      success: true,
      deletedKeys: keysArray
    }
  } else {
    return {
      success: false,
      deletedKeys: keysArray
    }
  }
})

export const GetServiceBusTopics = createAsyncThunk("appCommonReducers/GetServiceBusTopics", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetServiceBusTopics}`
  const resultData = await apiCall(method, endpoint, '')

  if (resultData) {
    // Handle both array response and wrapped response
    const topics = Array.isArray(resultData) ? resultData : (resultData.data || [])
    return {
      data: topics,
      spinner: false,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: false,
      tokenExp: false
    }
  }
})

export const GetServiceBusSubscriptions = createAsyncThunk("appCommonReducers/GetServiceBusSubscriptions", async (topicName) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetServiceBusSubscriptions}?topicName=${encodeURIComponent(topicName)}`
  const resultData = await apiCall(method, endpoint, '')

  if (resultData) {
    // Handle both array response and wrapped response
    const subscriptions = Array.isArray(resultData) ? resultData : (resultData.data || [])
    return subscriptions
  } else {
    return []
  }
})

export const GetServiceBusSubscriptionDetails = createAsyncThunk("appCommonReducers/GetServiceBusSubscriptionDetails", async ({ topicName, subscriptionName }) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetServiceBusSubscriptions}?topicName=${encodeURIComponent(topicName)}&subscriptionName=${encodeURIComponent(subscriptionName)}`
  const resultData = await apiCall(method, endpoint, '')

  if (resultData) {
    // Handle both array response and object response
    if (Array.isArray(resultData)) {
      return resultData
    } else if (resultData.data) {
      return Array.isArray(resultData.data) ? resultData.data : [resultData.data]
    } else {
      return [resultData]
    }
  } else {
    return []
  }
})

export const GetServiceBusCounts = createAsyncThunk("appCommonReducers/GetServiceBusCounts", async ({ topicName, subscriptionName }) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetServiceBusCounts}?topicName=${encodeURIComponent(topicName)}&subscriptionName=${encodeURIComponent(subscriptionName)}`
  const resultData = await apiCall(method, endpoint, '')

  if (resultData) {
    // Handle both direct data and wrapped response
    if (resultData.data) {
      return resultData.data
    } else if (resultData.active !== undefined || resultData.deadLetter !== undefined) {
      return resultData
    } else {
      return {
        active: 0,
        deadLetter: 0,
        transfer: 0,
        transferDeadLetter: 0
      }
    }
  } else {
    return {
      active: 0,
      deadLetter: 0,
      transfer: 0,
      transferDeadLetter: 0
    }
  }
})

export const GetDeadLetterMessages = createAsyncThunk("appCommonReducers/GetDeadLetterMessages", async ({ topicName, subscriptionName }) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetDeadLetterMessages}?topicName=${encodeURIComponent(topicName)}&subscriptionName=${encodeURIComponent(subscriptionName)}`
  const resultData = await apiCall(method, endpoint, '')

  if (resultData) {
    // Handle both array response and wrapped response
    if (Array.isArray(resultData)) {
      return resultData
    } else if (resultData.data && Array.isArray(resultData.data)) {
      return resultData.data
    } else {
      return []
    }
  } else {
    return []
  }
})

export const GetDeadLetterMessageById = createAsyncThunk("appCommonReducers/GetDeadLetterMessageById", async ({ topicName, subscriptionName, messageId }) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetDeadLetterMessageById}?topicName=${encodeURIComponent(topicName)}&subscriptionName=${encodeURIComponent(subscriptionName)}&messageId=${encodeURIComponent(messageId)}`
  const resultData = await apiCall(method, endpoint, '')

  if (resultData) {
    // Handle both direct data and wrapped response
    if (resultData.data) {
      return resultData.data
    } else {
      return resultData
    }
  } else {
    return null
  }
})

export const GetDeadLetterMessageProperties = createAsyncThunk("appCommonReducers/GetDeadLetterMessageProperties", async ({ topicName, subscriptionName, messageId }) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetDeadLetterMessageProperties}?topicName=${encodeURIComponent(topicName)}&subscriptionName=${encodeURIComponent(subscriptionName)}&messageId=${encodeURIComponent(messageId)}`
  const resultData = await apiCall(method, endpoint, '')

  if (resultData) {
    // Handle both direct data and wrapped response
    if (resultData.data) {
      return resultData.data
    } else if (resultData.success && resultData.data) {
      return resultData.data
    } else {
      return resultData
    }
  } else {
    return null
  }
})

export const RetryDeadLetterMessage = createAsyncThunk("appCommonReducers/RetryDeadLetterMessage", async ({ topicName, subscriptionName, messageId }) => {
  const method = 'get'
  const endpoint = `${ApiUrls.RetryDeadLetterMessage}?topicName=${encodeURIComponent(topicName)}&subscriptionName=${encodeURIComponent(subscriptionName)}&messageId=${encodeURIComponent(messageId)}`
  const resultData = await apiCall(method, endpoint, '')

  if (resultData) {
    // Handle both direct data and wrapped response
    if (resultData.data) {
      return resultData.data
    } else if (resultData.success && resultData.data) {
      return resultData.data
    } else {
      return resultData
    }
  } else {
    return null
  }
})

export const getRefreshToken = createAsyncThunk("appCommonReducers/getRefreshToken", async (_, { rejectWithValue }) => {
  try {
    const method = 'get'
    const endpoint = `User/GetRefreshToken`
    const data = ''
    const resultData = await apiCall(method, endpoint, data)
    if (resultData && resultData.id_token && resultData.refresh_token) {
      localStorage.setItem("token", resultData.id_token)
      localStorage.setItem("refresh_token", resultData.refresh_token)
      getUserApiCall()
      return {
        data: resultData,
        spinner: true,
        tokenExp: false
      }
    } else {
      return rejectWithValue({
        data: null,
        spinner: true,
        tokenExp: false,
        error: 'Failed to refresh token'
      })
    }
  } catch (error) {
    return rejectWithValue({
      data: null,
      spinner: true,
      tokenExp: false,
      error: error.message || 'Failed to refresh token'
    })
  }
})

export const commonreducerSlice = createSlice({
  name: 'appCommonReducers',
  initialState: {
    usersData: null,
    uspiner: false,
    userRoleData: [],
    urspiner: false,
    vesselReportByDate: [],
    dppReportByDate: [],
    docuSignData: [],
    docuSignSpinner: false,
    envelopeDetailsData: [],
    envelopeDetailsSpinner: false,
    categories: [],
    allroles: [],
     adtspiner: false,
    adsspiner: false,
    keysList: [],
    spinner: false,
    keyDetails: null,
    keyDetailsSpinner: false,
    categories: [],
    categoriesSpinner: false,
    keysPagination: {
      page: 1,
      pageSize: 9,
      total: 0
    },
    spinner1: false,
    combinedDocuments: null,
    combinedDocumentsSpinner: false,
    certificate: null,
    certificateSpinner: false,
    envelopeCustomFields: null,
    envelopeCustomFieldsSpinner: false,
    envelopeRecipients: null,
    envelopeRecipientsSpinner: false,
    envelopeDocuments: null,
    envelopeDocumentsSpinner: false,
    notification: null,
    notificationSpinner: false,
    serviceBusTopics: [],
    serviceBusTopicsSpinner: false
  },
   reducers: {
    clearKeyDetails: (state) => {
      state.keyDetails = null
      state.keyDetailsSpinner = false
    }
  },
  extraReducers: builder => {
    builder
      .addCase(displayMenu.fulfilled, (state, action) => {
        state.displayMenuBool = action.payload
      })
      // start role management
      .addCase(GetUsers.fulfilled, (state, action) => {
        if (action.payload) {
          state.uspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.usersData = action.payload.data
        }
      })
      .addCase(GetUserRoles.fulfilled, (state, action) => {
        if (action.payload) {
          state.urspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.userRoleData = action.payload.data
        }
      })
      .addCase(SaveUserRoles.fulfilled, (state, action) => {
        if (action.payload) {
          state.urspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
        }
      })
      .addCase(GetCategories.fulfilled, (state, action) => {
        if (action.payload) {
          state.spinner1 = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.categories = action.payload.data
        }
      })

      .addCase(GetAllKeys.pending, (state) => {
        state.spinner = true
      })
      .addCase(GetAllKeys.fulfilled, (state, action) => {
        state.keysList = action.payload.keys
        state.spinner = false
        if (action.payload.pagination) {
          state.keysPagination = action.payload.pagination
        }
      })
      .addCase(GetAllKeys.rejected, (state) => {
        state.spinner = false
      })

      .addCase(GetKeyDetails.pending, (state) => {
        state.keyDetailsSpinner = true
        state.keyDetails = null
      })
      .addCase(GetKeyDetails.fulfilled, (state, action) => {
        state.keyDetails = action.payload.keyDetails
        state.keyDetailsSpinner = action.payload.keyDetailsSpinner
      })
      .addCase(GetKeyDetails.rejected, (state) => {
        state.keyDetailsSpinner = false
        state.keyDetails = null
      })

      .addCase(GetServiceBusTopics.pending, (state) => {
        state.serviceBusTopicsSpinner = true
      })
      .addCase(GetServiceBusTopics.fulfilled, (state, action) => {
        if (action.payload) {
          state.serviceBusTopics = action.payload.data || []
          state.serviceBusTopicsSpinner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
        }
      })
      .addCase(GetServiceBusTopics.rejected, (state) => {
        state.serviceBusTopicsSpinner = false
        state.serviceBusTopics = []
      })

      .addCase(DeleteKeys.fulfilled, (state, action) => {
        if (action.payload.success) {
          state.keysList = state.keysList.filter(key => !action.payload.deletedKeys.includes(key))
          if (state.keyDetails && action.payload.deletedKeys.includes(state.keyDetails.key)) {
            state.keyDetails = null
          }
        }
      })

      .addCase(GetDPPReportByDate.fulfilled, (state, action) => {
        if (action.payload) {
          state.urspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.dppReportByDate = action.payload.data
        }
      })
      .addCase(GetAllRoles.fulfilled, (state, action) => {
        if (action.payload) {
          state.urspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.allroles = action.payload.data
        }
      })
      .addCase(GetFilteredEnvelopes.pending, (state) => {
        state.docuSignSpinner = true
      })
      .addCase(GetFilteredEnvelopes.fulfilled, (state, action) => {
        if (action.payload) {
          state.docuSignSpinner = false 
          state.tokenExp = action.payload.tokenExp
          state.docuSignData = action.payload.data
        }
      })
      .addCase(GetFilteredEnvelopes.rejected, (state) => {
        state.docuSignSpinner = false
        state.docuSignData = []
      })
      .addCase(GetEnvelopebyEnvelopeId.pending, (state) => {
        state.envelopeDetailsSpinner = true
      })
      .addCase(GetEnvelopebyEnvelopeId.fulfilled, (state, action) => {
        if (action.payload) {
          state.envelopeDetailsSpinner = false
          state.tokenExp = action.payload.tokenExp
          state.envelopeDetailsData = action.payload.data
        }
      })
      .addCase(GetEnvelopebyEnvelopeId.rejected, (state) => {
        state.envelopeDetailsSpinner = false
        state.envelopeDetailsData = []
      })
      .addCase(GetCombinedDocuments.pending, (state) => {
        state.combinedDocumentsSpinner = true
        state.combinedDocuments = null
      })
      .addCase(GetCombinedDocuments.fulfilled, (state, action) => {
        if (action.payload) {
          state.combinedDocumentsSpinner = false
          state.combinedDocuments = action.payload.data
          state.tokenExp = action.payload.tokenExp
        }
      })
      .addCase(GetCombinedDocuments.rejected, (state) => {
        state.combinedDocumentsSpinner = false
        state.combinedDocuments = null
      })
      .addCase(GetCertificate.pending, (state) => {
        state.certificateSpinner = true
        state.certificate = null
      })
      .addCase(GetCertificate.fulfilled, (state, action) => {
        if (action.payload) {
          state.certificateSpinner = false
          state.certificate = action.payload.data
          state.tokenExp = action.payload.tokenExp
        }
      })
      .addCase(GetCertificate.rejected, (state) => {
        state.certificateSpinner = false
        state.certificate = null
      })
      .addCase(GetEnvelopeCustomFields.pending, (state) => {
        state.envelopeCustomFieldsSpinner = true
        state.envelopeCustomFields = null
      })
      .addCase(GetEnvelopeCustomFields.fulfilled, (state, action) => {
        if (action.payload) {
          state.envelopeCustomFieldsSpinner = false
          state.envelopeCustomFields = action.payload.data
          state.tokenExp = action.payload.tokenExp
        }
      })
      .addCase(GetEnvelopeCustomFields.rejected, (state) => {
        state.envelopeCustomFieldsSpinner = false
        state.envelopeCustomFields = null
      })
      .addCase(GetEnvelopeRecipients.pending, (state) => {
        state.envelopeRecipientsSpinner = true
        state.envelopeRecipients = null
      })
      .addCase(GetEnvelopeRecipients.fulfilled, (state, action) => {
        if (action.payload) {
          state.envelopeRecipientsSpinner = false
          state.envelopeRecipients = action.payload.data
          state.tokenExp = action.payload.tokenExp
        }
      })
      .addCase(GetEnvelopeRecipients.rejected, (state) => {
        state.envelopeRecipientsSpinner = false
        state.envelopeRecipients = null
      })
      .addCase(GetEnvelopeDocuments.pending, (state) => {
        state.envelopeDocumentsSpinner = true
        state.envelopeDocuments = null
      })
      .addCase(GetEnvelopeDocuments.fulfilled, (state, action) => {
        if (action.payload) {
          state.envelopeDocumentsSpinner = false
          state.envelopeDocuments = action.payload.data
          state.tokenExp = action.payload.tokenExp
        }
      })
      .addCase(GetEnvelopeDocuments.rejected, (state) => {
        state.envelopeDocumentsSpinner = false
        state.envelopeDocuments = null
      })
      .addCase(GetNotification.pending, (state) => {
        state.notificationSpinner = true
        state.notification = null
      })
      .addCase(GetNotification.fulfilled, (state, action) => {
        if (action.payload) {
          state.notificationSpinner = false
          state.notification = action.payload.data
          state.tokenExp = action.payload.tokenExp
        }
      })
      .addCase(GetNotification.rejected, (state) => {
        state.notificationSpinner = false
        state.notification = null
      })
  }
})
export const { handleAddtoCart, clearKeyDetails } = commonreducerSlice.actions
export default commonreducerSlice.reducer
